import { BuyerAppeals } from "@/types/Api/Market/Order/buyerAppeals";
import { BuyerConfirmsOrderHasBeenPaid } from "@/types/Api/Market/Order/buyerConfirmsOrderHasBeenPaid";
import { GetCancelsOrderDailyCount } from "@/types/Api/Market/Order/getCancelsOrderDailyCount";
import { GetCurrentOrderStatus } from "@/types/Api/Market/Order/getCurrentOrderStatus";
import { MyOrderDetail } from "@/types/Api/Market/Order/myOrderDetail";
import { GetOrderListByPendingOrder } from "@/types/Api/Market/PendingOrder/getOrderListByPendingOrder";
import { MarketPendingOrderDetail } from "@/types/Api/Market/PendingOrder/marketPendingOrderDetail";
import { MarketPendingOrderList } from "@/types/Api/Market/PendingOrder/marketPendingOrderList";
import { MyPendingOrderDetail } from "@/types/Api/Market/PendingOrder/myPendingOrderDetail";
import { Index } from "@/types/Api/Market/Sell";
import { request } from "@/utils/request";
import { CrypptoMerchantURLOptions, crypptoMerchantURL } from "./utils";

export const marketPendingOrderList = (
  data: MarketPendingOrderList["request"],
  options?: CrypptoMerchantURLOptions
) =>
  request<MarketPendingOrderList["response"]>({
    url: `/Api/Market/${crypptoMerchantURL(options)}PendingOrder/marketPendingOrderList`,
    method: "POST",
    data,
  });

export const myOrderList = (data: any, options?: CrypptoMerchantURLOptions) =>
  request<any>({
    url: !options?.isBlock?`/Api/Market/Order/myOrderList`:`/Api/User/Business/getOrderList`,
    method: !options?.isBlock?"GET":"POST",
    data,
  });

export const createSaleOrder = (data: Index["request"], options?: CrypptoMerchantURLOptions) =>
  request<Index["response"]>({
    url: `/Api/Market/${crypptoMerchantURL(options)}Sell/index`,
    method: "POST",
    data,
  });

  //超级商家挂单
export const createProfessionSaleOrder = (data: Index["request"], options?: CrypptoMerchantURLOptions) =>
    request<Index["response"]>({
      url: `/Api/Market/BusinessSell/professionindex`,
      method: "POST",
      data,
    });


// 撤销卖单
export const recycle = (data: { pendingOrderId: number }, options?: CrypptoMerchantURLOptions) =>
  request<any>({
    url: `/Api/Market/${crypptoMerchantURL(options)}Sell/recycle`,
    method: "POST",
    data,
  });

// 我的挂单
export const myPendingOrderList = (data: any) =>
  request<any>({
    url: "/Api/Market/PendingOrder/myPendingOrderList",
    method: "POST",
    data,
  });

// 买单
export const myOrderDetail = (data: MyOrderDetail["request"], options?: CrypptoMerchantURLOptions) =>
  request<MyOrderDetail["response"]>({
    url: `/Api/Market/${crypptoMerchantURL(options)}Order/myOrderDetail`,
    method: "GET",
    data,
  });

// 交易中心卖单详情
export const marketPendingOrderDetail = (
  data: MarketPendingOrderDetail["request"], options?: CrypptoMerchantURLOptions
) =>
  request<MarketPendingOrderDetail["response"]>({
    url: `/Api/Market/${crypptoMerchantURL(options)}PendingOrder/marketPendingOrderDetail`,
    method: "POST",
    data,
  });

// 刷新订单状态
export const getCurrentOrderStatus = (data: GetCurrentOrderStatus["request"], options?: CrypptoMerchantURLOptions) =>
  request<GetCurrentOrderStatus["response"]>({
    url: `/Api/Market/${crypptoMerchantURL(options)}Order/getCurrentOrderStatus`,
    method: "GET",
    data,
  });

// 我的挂单详情
export const myPendingOrderDetail = (data: MyPendingOrderDetail["request"], options?: CrypptoMerchantURLOptions) =>
  request<MyPendingOrderDetail["response"]>({
    url: `/Api/Market/${crypptoMerchantURL(options)}PendingOrder/myPendingOrderDetail`,
    method: "GET",
    data,
  });

// 买家创建购买订单
export const buyerCreatesOrder = (data: {
  pendingOrderId: string;
  amount: string;
  buyerPaymentTypeId: string;
  paymentType: string;
}, options?: CrypptoMerchantURLOptions
) =>
  request<{ orderId: string }>({
    url: `/Api/Market/${crypptoMerchantURL(options)}Order/buyerCreatesOrder`,
    method: "POST",
    data,
  });

// 取销售单（挂单）相关联的订单列表
export const getOrderListByPendingOrder = (
  data: GetOrderListByPendingOrder["request"], options?: CrypptoMerchantURLOptions
) =>
  request<GetOrderListByPendingOrder["response"]>({
    url: `/Api/Market/${crypptoMerchantURL(options)}PendingOrder/getOrderListByPendingOrder`,
    method: "GET",
    data,
  });

// 卖家取消订单
export const sellerRefusesToCreateOrder = (data: { orderId: string }, options?: CrypptoMerchantURLOptions) =>
  request<any>({
    url: `/Api/Market/${crypptoMerchantURL(options)}Order/sellerRefusesToCreateOrder`,
    method: "POST",
    data,
  });

// 卖家同意订单
export const sellerConfirmsToCreateOrder = (data: { orderId: string }, options?: CrypptoMerchantURLOptions) =>
  request<any>({
    url: `/Api/Market/${crypptoMerchantURL(options)}Order/sellerConfirmsToCreateOrder`,
    method: "POST",
    data,
  });

// 卖家没有收到转账
export const sellerHasNotReceivedPayment = (data: { orderId: string },options?: CrypptoMerchantURLOptions) =>
  request<any>({
    url: `/Api/Market/${crypptoMerchantURL(options)}Order/sellerHasNotReceivedPayment`,
    method: "POST",
    data,
  });

// 卖家同意转币
export const sellerCompletesOrder = (data: {
  orderId: string;
  securePassword: string;
},options?: CrypptoMerchantURLOptions) =>
  request<any>({
    url: `/Api/Market/${crypptoMerchantURL(options)}Order/sellerCompletesOrder`,
    method: "POST",
    data,
  });

// 买家取消订单
export const buyerCancelsOrder = (data: { orderId: number },options?: CrypptoMerchantURLOptions) =>
  request<any>({
    url: `/Api/Market/${crypptoMerchantURL(options)}Order/buyerCancelsOrder`,
    method: "POST",
    data,
  });

// 买家确认转账
export const buyerConfirmsOrderHasBeenPaid = (
  data: BuyerConfirmsOrderHasBeenPaid["request"],options?: CrypptoMerchantURLOptions
) =>
  request<BuyerConfirmsOrderHasBeenPaid["response"]>({
    url: `/Api/Market/${crypptoMerchantURL(options)}Order/buyerConfirmsOrderHasBeenPaid`,
    method: "POST",
    data,
  });

// 申请争议订单
export const buyerAppeals = (data: BuyerAppeals["request"],options?: CrypptoMerchantURLOptions) =>
  request<BuyerAppeals["response"]>({
    url: `/Api/Market/${crypptoMerchantURL(options)}Order/buyerAppeals`,
    method: "POST",
    data,
  });

// 获取当日取消订单数
export const getCancelsOrderDailyCount = (
  data: GetCancelsOrderDailyCount["request"],options?: CrypptoMerchantURLOptions
) =>
  request<GetCancelsOrderDailyCount["response"]>({
    url: `/Api/Market/${crypptoMerchantURL(options)}Order/getCancelsOrderDailyCount`,
    method: "GET",
    data,
  });


export const getDeviceInfo = (data: any) =>
  request<any>({
    url: "/Api/User/Info/getDeviceInfo",
    method: "GET",
    data,
  });

  // 发起三方支付
export const getPaymentOrderOrderId = (data: any) =>
  request<any>({
    url: `/Api/Market/Order/paymentOrder`,
    method: "POST",
    data,
  });